import { MarketListResponse } from '../../types/markets/types';
import { getCustomerIdFromToken } from '../../utils/getCustomerIdFromToken';
import { analytics } from '../../utils/analytics';
import { get } from '../apiService';

export const getMarketList = async (
  marketId?: string[],
  names?: string[],
  states?: string[],
  includeExternal?: boolean
): Promise<{ data: MarketListResponse | null; loading: boolean }> => {
  const customer = getCustomerIdFromToken();
  if (!customer) {
    throw new Error('Customer ID is not available');
  }

  // Construct the base URL with the required customerId parameter
  let url = `resourceMatrix/market/list?customerId=${customer}`;

  // Add optional query parameters if provided
  if (marketId?.length) {
    url += `&marketId=${marketId.join(',')}`;
  }
  if (names?.length) {
    url += `&names=${names.join(',')}`;
  }
  if (states?.length) {
    url += `&states=${states.join(',')}`;
  }
  if (typeof includeExternal === 'boolean') {
    url += `&includeExternal=${includeExternal}`;
  }

  let loading = true;

  try {
    // Make the API call
    const responseData = await get(url);
    const data = responseData as MarketListResponse;
    loading = false;
    analytics.trackEvent('list', 'market');
    return { data, loading };
  } catch (error) {
    // Handle errors gracefully
    loading = false;
    console.error('Failed to fetch market list:', error);
    throw new Error('Failed to fetch market list');
  }
};
